// 用数字是为了可以比较大小
export enum SizeEnum {
	xs = 1,
	small,
	middle,
	large,
	xl,
	xxl,
}
